// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__b6Jna","total":"Cart_total__haOvR","actions":"Cart_actions__k8hLP","button--alt":"Cart_button--alt__Q9xNB","button":"Cart_button__JHPeR"};